import { render, staticRenderFns } from "./discountTag.vue?vue&type=template&id=7b97c560&scoped=true&"
import script from "./discountTag.vue?vue&type=script&lang=js&"
export * from "./discountTag.vue?vue&type=script&lang=js&"
import style0 from "./discountTag.vue?vue&type=style&index=0&id=7b97c560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97c560",
  null
  
)

export default component.exports